import React from "react";
const SvgBellFilled = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#000"
      d="M5.57 19.019h12.867c.53 0 1.02-.263 1.31-.696.3-.444.34-.999.11-1.483a17.212 17.212 0 01-1.64-7.314c0-2.178-1.47-4.216-3.692-5.104-.5-.867-1.46-1.412-2.521-1.412-1.06 0-2.011.545-2.511 1.392a6.45 6.45 0 00-1.921 1.17c-1.15 1.019-1.781 2.37-1.781 3.803v.151c0 2.512-.55 4.973-1.64 7.314a1.51 1.51 0 00.11 1.483c.29.433.78.696 1.31.696zm3.8.871c.43.95 1.45 1.62 2.63 1.62s2.2-.67 2.63-1.62H9.36h.01z"
    />
  </svg>
);
export default SvgBellFilled;
